import { lanzamientoimgs } from "./images";
import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const LanzamientoBanner = () => {
  return (
    <Container>
      <div>
        <picture>
          <source media="(max-width: 768px)" srcSet={lanzamientoimgs.mobile} />
          <source media="(max-width: 1024px)" srcSet={lanzamientoimgs.tablet} />
          <source media="(max-width: 1366px)" srcSet={lanzamientoimgs.standard} />
          <img src={lanzamientoimgs.hd} alt="Lanzamiento Fleischmann" />
        </picture>
        <a href="/bizcochuelo" target="blank" className="banner-btn-link">
          <Button
            sx={{
              zIndex: 100,
              backgroundColor: "#cf7647",
              color: "#fff",
              fontSize: "1.2rem",
              padding: "12px 28px",
              "&:hover": {
                backgroundColor: "#b86e3a",
              },
              /* HD (>1366px) */
              "@media (min-width: 1367px)": {
                fontSize: "1.3rem",
                padding: "14px 32px",
              },
              /* Standard (1025px – 1366px) */
              "@media (max-width: 1366px)": {
                fontSize: "1.3rem",
                padding: "14px 32px",
              },
              /* Tablet (769px – 1024px) */
              "@media (max-width: 1024px)": {
                fontSize: "1.2rem",
                padding: "12px 28px",
              },
              /* Mobile (≤768px) */
              "@media (max-width: 768px)": {
                fontSize: "1.1rem !important",
                padding: "10px 24px",
              },
            }}
            variant="contained"
          >
            QUIERO PARTICIPAR
          </Button>
        </a>
      </div>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 100px;
  @media (max-width: 768px) {
    margin-top: 70px;
  }

  > div {
    width: 100%;
    margin-inline: auto;
    position: relative;

    picture {
      display: block;
      width: 100%;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
      object-fit: cover;
    }

    .banner-btn-link {
      position: absolute;
      top: 70%;
      left: 9%;

      /* Standard (1025px – 1366px) */
      @media (max-width: 1366px) {
        top: 70%;
        left: 8%;
      }

      /* Tablet (769px – 1024px) */
      @media (max-width: 1024px) {
        top: 70%;
        left: 6%;
      }

      /* Mobile (≤768px) */
      @media (max-width: 768px) {
        top: 92%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`;
